import { Action } from "redux";
import { ChatUsers } from "../../types/chat/Chat";

export const FETCH_CHAT_USERS_REQUEST = 'FETCH_CHAT_USERS_REQUEST';
export const FETCH_CHAT_USERS_SUCCESS = 'FETCH_CHAT_USERS_SUCCESS';
export const FETCH_CHAT_USERS_FAILURE = 'FETCH_CHAT_USERS_FAILURE';

export interface FetchChatUsersRequestAction extends Action<typeof FETCH_CHAT_USERS_REQUEST> {
  type: typeof FETCH_CHAT_USERS_REQUEST;
}

export interface FetchChatUsersSuccessAction extends Action<typeof FETCH_CHAT_USERS_SUCCESS> {
  type: typeof FETCH_CHAT_USERS_SUCCESS;
  payload: {
    data: ChatUsers[],
    meta: any
  };
}

export interface FetchChatUsersFailureAction extends Action<typeof FETCH_CHAT_USERS_FAILURE> {
  type: typeof FETCH_CHAT_USERS_FAILURE;
  payload: string;
}


export type EmpresasActionTypes =
  | FetchChatUsersRequestAction
  | FetchChatUsersSuccessAction
  | FetchChatUsersFailureAction;